import { useSelector, useDispatch } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Box, Toolbar, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Sidebar, { DRAWER_WIDTH, DRAWER_WIDTH_COLLAPSED } from './Sidebar';
import Header from './Header';
import { setSidebar } from '@/redux/slices/uiSlice';
import ErrorBoundary from '@/components/common/ErrorBoundary';

// Authenticated app shell: permanent drawer on desktop, temporary on mobile.
export default function MainLayout() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const sidebarOpen = useSelector((s) => s.ui.sidebarOpen);
  const sidebarCollapsed = useSelector((s) => s.ui.sidebarCollapsed);
  const navWidth = sidebarCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;

  return (
    <Box sx={{ display: 'flex' }}>
      <Box component="nav" sx={{ width: { md: navWidth }, flexShrink: { md: 0 } }}>
        <Sidebar
          variant={isDesktop ? 'permanent' : 'temporary'}
          open={isDesktop ? true : sidebarOpen}
          collapsed={sidebarCollapsed}
          onClose={() => dispatch(setSidebar(false))}
        />
      </Box>
      <Box sx={{ flexGrow: 1, width: { md: `calc(100% - ${navWidth}px)` } }}>
        <Header />
        <Toolbar />
        <Box component="main" sx={{ p: { xs: 2, md: 3 }, minHeight: 'calc(100vh - 64px)', bgcolor: 'background.default' }}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </Box>
      </Box>
    </Box>
  );
}
